// removed by extract-text-webpack-plugin
module.exports = {"crumbsContainer":"Breadcrumbs__crumbsContainer___3RSDK","crumb":"Breadcrumbs__crumb___gkCdp","crumbActive":"Breadcrumbs__crumbActive___2cQrc"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Breadcrumbs/Breadcrumbs.scss
 ** module id = 1338
 ** module chunks = 0
 **/